export interface Testimonial {
  quote: string
  author: string
  role: string
  location: string
}

export const testimonials: Testimonial[] = [
  {
    quote:
      'Non perdo più le domeniche a cercare sequenze. Apro il kit, scelgo la classe ed entro in sala completamente preparata. I miei studenti sentono la differenza.',
    author: 'M.R.',
    role: 'Insegnante di Yoga',
    location: 'Milano',
  },
  {
    quote:
      'Le varianti intelligenti mi hanno salvato con i gruppi misti. Non improvviso più e i principianti non si sentono persi. Perfetto.',
    author: 'E.T.',
    role: 'Istruttrice di Yoga',
    location: 'Roma',
  },
  {
    quote:
      'Il cueing e gli script di chiusura hanno cambiato completamente come insegno. La mia voce è più sicura, le transizioni scorrono naturali. Finalmente sembra professionale.',
    author: 'L.P.',
    role: 'Insegnante Freelance',
    location: 'Torino',
  },
]
